/**
 * Sharing a table is a link, not a code to read aloud — the link lands on the
 * public preview, which is what makes a stranger's first tap cheap.
 */
import { useState } from 'react'
import { Sheet } from '../table/PromptSheet'

export function InviteShare({
  code,
  gameName,
  onClose,
}: {
  code: string
  gameName: string
  onClose: () => void
}): JSX.Element {
  const [copied, setCopied] = useState(false)
  const url = `${location.origin}/t/${code}`

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'cards', text: `Come and play ${gameName}`, url })
        return
      } catch {
        /* the sheet was dismissed — fall through to copying */
      }
    }
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <Sheet onDismiss={onClose}>
      <div className="sheet-body">
        <h2>Invite to the table</h2>
        <div className="code" style={{ justifyContent: 'center' }}>
          {code}
        </div>
        <div className="option-row">
          <button className="btn btn-secondary" onClick={onClose}>
            Done
          </button>
          <button className="btn btn-primary" onClick={() => void share()}>
            {copied ? 'Link copied' : 'Share the link'}
          </button>
        </div>
      </div>
    </Sheet>
  )
}
